import React from "react"
import { PageSections } from "../../../../../types/routes"
import isListItemSelected from "../../../../../utils/isListItemSelected"
import OutsideAlerter from "../../../../../../OutsideAlerter"
import SubList from "./components/SubList/SubList"
import ListItemContent from "./components/ListItemContent/ListItemContent"

type Props = {
  children: React.ReactNode
  isLast: boolean
  section: PageSections
}

const ListItem = ({ children, isLast, section }: Props) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const backgroundColor = isListItemSelected(section)
    ? "bg-white bg-opacity-10"
    : ""

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === "Enter") {
      setIsOpen(!isOpen)
    }

    if (e.key === "Tab" && isOpen) {
      setIsOpen(false)
    }
  }

  return (
    <OutsideAlerter onClick={() => setIsOpen(false)}>
      <li
        className={`h-full py-2 md:px-2 lg:px-3 cursor-pointer ${backgroundColor} group`}
        onClick={handleClick}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <ListItemContent isOpen={isOpen}>{children}</ListItemContent>
      </li>
      <SubList isLast={isLast} isOpen={isOpen} section={section} />
    </OutsideAlerter>
  )
}

export default ListItem
